import React from "react";
import { Button, IconButton, Image } from "@chakra-ui/react";
import deleteBtn from "../../assets/waveflowmain/deleteBtn.png";
import downloadBtn from  "../../assets/waveflowmain/downloadBtn.png"

const DownloadJsonFile = ({ dataDownload }) => {
  // const {id,session_id,model,...agentsData}=dataDownload
  // const {api_key,...modelRemove}=model
  // const newDataDownLoad={...agentsData,model:{api_key:"",...modelRemove}}

  const downloadJSON = () => {
    const data = dataDownload;

    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(data, null, 2)
    )}`;

    const link = document.createElement("a");
    link.href = jsonString;
    link.download =
      `${dataDownload?.client || dataDownload?.name}.json` || "data.json";
    link.click();
  };

  return (
   
      <IconButton
        onClick={downloadJSON}
        icon={<Image src={downloadBtn} alt="download" width={"18px"} />}
        size="sm"
        colorScheme="red"
        variant="ghost"
        aria-label="Delete item"
        p={0}
        m={0}
      />
    
  );
};

export default DownloadJsonFile;
